module.exports = __webpack_public_path__ + "static/img/wenxiBg.a69896b9.jpg";